import { Component } from "@angular/core";

@Component({
  selector: "evta-auth-footer",
  templateUrl: "./auth-footer.component.html",
  styleUrls: ["./auth-footer.component.scss"],
  standalone: false,
})
export class AuthFooterComponent {
  currentYear = new Date().getFullYear();
}
